import type { RouteRecordRaw } from 'vue-router'

export const booksRoutes: RouteRecordRaw[] = [
  {
    path: '/books',
    name: 'books',
    component: () => import('./pages/BooksPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/books/:id',
    name: 'book-detail',
    component: () => import('./pages/BookDetailsPage.vue'),
    meta: { requiresAuth: true },
  },
]
